export default __webpack_public_path__ + "static/media/ntorque.3e332d48.webp";